import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileItem } from 'ng2-file-upload';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { timeout } from 'rxjs/operators';
import { Area } from '../../core/constants/area';

@Injectable()
export class IndustryService {

  constructor(public httpClient: HttpClient) { }

  getIndustryList(){
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/Industry/List/`;
    return this.httpClient.get<any[]>(url);
  }
  getIndustryDashboard(){
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/Industry/Dashboard/`;
    return this.httpClient.get<any[]>(url);
  }
  getFinancialDashboard(){
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/Industry/FinancialDashboard/`;
    return this.httpClient.get<any[]>(url);
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/industry/industry.service.ts